import * as React from 'react';

import {NothingFoundEmptyState} from 'shells/empty-states/nothing-found-empty-state';
import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {GridList} from 'shells/grid-list/grid-list';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {SearchBar} from 'shells/search-bar/search-bar';

import type {GetImport2CrmOptions_import2CrmOptions} from 'nutshell-graphql-types';

import {useGetCrmListData} from '../../import2/graphql/hooks/use-get-crms-list-data';

import {CrmRow} from './crm-row';

type Props = {
    onCloseModal: () => void;
};

export function AnotherCrmPage(props: Props) {
    const [crms, setCrms] = React.useState<GetImport2CrmOptions_import2CrmOptions[]>([]);
    const [search, setSearch] = React.useState('');
    const [chosenCrmLabel, setChosenCrmLabel] = React.useState<string>('');
    const {isLoading, crmOptions, onInitiateImport, initiateError} = useGetCrmListData();

    React.useEffect(() => {
        if (!crms.length && crmOptions.length) {
            setCrms(crmOptions);
        }
    }, [crmOptions, crms]);

    React.useEffect(() => {
        if (search.length) {
            setCrms(
                crmOptions.filter((crm) => crm.label.toLowerCase().includes(search.toLowerCase()))
            );
        } else {
            setCrms(crmOptions);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    const shouldShowNothingFound = search.length && !crms.length;

    return (
        <>
            {isLoading ? (
                <LoadingPage />
            ) : (
                <>
                    {initiateError && chosenCrmLabel && (
                        <FlashBanner type='error' isOverlay={true} duration={6000}>
                            Oops – something went wrong starting an import from {chosenCrmLabel} -
                            please try again and contact our support team if this error persists!
                        </FlashBanner>
                    )}
                    <div className='mb-16 mr-8'>
                        <SearchBar onChange={setSearch} value={search} hasBorder={true} />
                    </div>
                    {shouldShowNothingFound ? (
                        <NothingFoundEmptyState />
                    ) : (
                        <GridList numColumns={1}>
                            {crms.map((crm) => (
                                <CrmRow
                                    key={crm.type}
                                    type={crm.type}
                                    label={crm.label}
                                    onInitiateImport={() => {
                                        setChosenCrmLabel(crm.label);
                                        onInitiateImport(crm.type, props.onCloseModal);
                                    }}
                                />
                            ))}
                        </GridList>
                    )}
                </>
            )}
        </>
    );
}
